// src/redux/giftSlice.js
import { createSlice } from "@reduxjs/toolkit"

const giftSlice = createSlice({
  name: "gift",
  initialState: {
    listGift: [],
  },
  reducers: {
    setListGift: (state, action) => {
      state.listGift = action.payload
    },
  },
})

export const { setListGift } = giftSlice.actions
export default giftSlice.reducer
